import Modal, { ModalTitle, ModalSubtitle } from '../Modal/Modal';
import Button from '../Button/Button';

const ConfirmModal = ({
    title,
    message = 'Are you sure? This action cannot be undone',
    confirmLabel,
    onConfirm,
    onClose,
}) => {
    return (
        <Modal onClose={onClose} showClose={false} centered>
            <ModalTitle>{title}</ModalTitle>
            <ModalSubtitle className="mt-3 mb-4">{message}</ModalSubtitle>

            <div className="d-flex gap-3">
                <Button variant="outline" className="flex-fill" onClick={onClose}>
                    Cancel
                </Button>
                <Button variant="danger" className="flex-fill" onClick={onConfirm}>
                    {confirmLabel}
                </Button>
            </div>
        </Modal>
    );
};

export default ConfirmModal;
